import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX, FiPhone } = FiIcons;
const links = ['Services', 'Why Us', 'Gallery', 'Reviews', 'FAQ', 'Contact'];

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    const updateHeader = () => setScrolled(window.scrollY > window.innerHeight * 0.55);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
    return () => window.removeEventListener('scroll', updateHeader);
  }, []);

  const close = () => setOpen(false);

  return (
    <header className={`site-header ${scrolled || open ? 'solid' : ''}`}>
      <a className="brand" href="#top" aria-label="Windy City Painters home">
        <img src="/windy-city-logo.svg" alt="Windy City Painters" />
        <span>WINDY CITY <b>PAINTERS</b></span>
      </a>

      <nav className="desktop-nav" aria-label="Main navigation">
        {links.map((link) => (
          <a key={link} href={`#${link.toLowerCase().replace(' ', '-')}`}>{link}</a>
        ))}
      </nav>

      <div className="header-actions">
        <a className="header-phone" href="tel:+15126792228">
          <SafeIcon icon={FiPhone} />
          <span>512-679-2228</span>
        </a>
        <a className="button compact" href="#contact">Get Free Estimate</a>
        <button
          className="menu-button"
          type="button"
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
          aria-label="Toggle navigation"
        >
          <SafeIcon icon={open ? FiX : FiMenu} />
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            className="mobile-drawer"
            aria-label="Mobile navigation"
            initial={reduceMotion ? false : { x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          >
            {links.map((link, index) => (
              <motion.a
                key={link}
                href={`#${link.toLowerCase().replace(' ', '-')}`}
                onClick={close}
                initial={reduceMotion ? false : { opacity: 0, x: 24 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.06 }}
              >
                {link}
              </motion.a>
            ))}
            <a href="tel:+15126792228" onClick={close}>512-679-2228</a>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}

export default Header;